import { render, staticRenderFns } from "./comment-or-reply.vue?vue&type=template&id=24efe13b&"
import script from "./comment-or-reply.vue?vue&type=script&lang=ts&"
export * from "./comment-or-reply.vue?vue&type=script&lang=ts&"
import style0 from "./comment-or-reply.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports